import * as factories from './factories';
import * as transforms from './transforms';

export const MeModel = {
  ...factories,
  ...transforms,
};
